var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0322 9.40912C18.0322 8.75677 17.9736 8.12951 17.8649 7.52734H9.2002V11.086H14.1515C13.9382 12.236 13.29 13.2103 12.3156 13.8626V16.171H15.2889C17.0286 14.5694 18.0322 12.2109 18.0322 9.40912Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19997 18.401C11.684 18.401 13.7665 17.5772 15.2887 16.1722L12.3154 13.8639C11.4916 14.4159 10.4378 14.742 9.19997 14.742C6.80379 14.742 4.77561 13.1237 4.05215 10.9492H0.978516V13.3328C2.49233 16.3395 5.60361 18.401 9.19997 18.401Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.05218 10.9479C3.86818 10.3959 3.76364 9.80625 3.76364 9.1999C3.76364 8.59355 3.86818 8.00393 4.05218 7.45194V5.06836H0.978545C0.355455 6.31033 0 7.71539 0 9.1999C0 10.6844 0.355455 12.0895 0.978545 13.3314L4.05218 10.9479Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19997 3.659C10.5507 3.659 11.7634 4.12317 12.7169 5.03479L15.3556 2.39612C13.7623 0.911615 11.6798 0 9.19997 0C5.60361 0 2.49233 2.06159 0.978516 5.06824L4.05215 7.45182C4.77561 5.27733 6.80379 3.659 9.19997 3.659Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.87b3dd50bdbf094d6e6d7d7767d7e370.svg";
export { ForwardRef as ReactComponent };